import { APP_CLIENT } from '@/lib/constants/appClient'

type WhitelabelConfig = {
  iosAppLink: string
  androidAppLink: string
  title: string
}

type WhitelabelConfigs = Record<typeof APP_CLIENT, WhitelabelConfig>

const defaultTitle = import.meta.env.VITE_APP_TITLE

const whitelabelConfigs = {
  eig: {
    androidAppLink: 'https://play.google.com/store/apps/details?id=io.eigtech.nutmeg',
    iosAppLink: 'https://apps.apple.com/us/app/eig-inspections/id6747015727',
    title: defaultTitle || 'EIG Portal',
  },
  ryze: {
    androidAppLink: 'https://play.google.com/store/apps/details?id=io.eigtech.ryze',
    iosAppLink: 'https://apps.apple.com/app/ryze-inspections/id6788192704',
    title: defaultTitle || 'Ryze Portal',
  },
} satisfies WhitelabelConfigs

export const whitelabelConfig = whitelabelConfigs[APP_CLIENT]
